export default "__VITE_ASSET__92a8146b__"